/**
 * A2UI Card Component
 * Container with optional header, body styling
 */

import React from 'react';
import { Card } from 'react-bootstrap';

const A2UICard = ({ 
  child,
  header,
  elevation = 1,
  style,
  resolveValue,
  renderChild,
  surfaceId
}) => {
  const resolvedHeader = resolveValue ? resolveValue(header, surfaceId) : header?.literalString;
  
  // Map elevation to box-shadow
  const shadowMap = {
    0: 'none',
    1: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    2: '0 3px 6px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.12)',
    3: '0 10px 20px rgba(0,0,0,0.15), 0 3px 6px rgba(0,0,0,0.10)',
    4: '0 15px 25px rgba(0,0,0,0.15), 0 5px 10px rgba(0,0,0,0.05)',
  };

  const cardStyle = {
    boxShadow: shadowMap[elevation] || shadowMap[1],
    marginBottom: '1rem',
    ...style
  };

  return (
    <Card className="a2ui-card" style={cardStyle}>
      {resolvedHeader && (
        <Card.Header className="a2ui-card-header">
          {resolvedHeader}
        </Card.Header>
      )}
      <Card.Body className="a2ui-card-body">
        {child && renderChild ? renderChild(child) : null}
      </Card.Body>
    </Card>
  );
};

export default A2UICard;
